"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = require("@emotion/react");

var _reactFeather = require("react-feather");

var _Icon = _interopRequireDefault(require("../icon/Icon"));

var _Hold = _interopRequireDefault(require("../layout/Hold"));

var _theme = _interopRequireWildcard(require("../../theme/theme"));

var _templateObject, _templateObject2, _templateObject3;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var getUnit = function getUnit(strValue) {
  return strValue.match(/[a-z, %]+$/)[0] || "";
};

var parseAspectRatio = function parseAspectRatio(strValue) {
  var _strValue$split = strValue.split(":"),
      _strValue$split2 = _slicedToArray(_strValue$split, 2),
      wx = _strValue$split2[0],
      hx = _strValue$split2[1];

  return [Number(wx), Number(hx)];
};

var Picture = function Picture(_ref) {
  var className = _ref.className,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? "" : _ref$alt,
      src = _ref.src,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? "auto" : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? "auto" : _ref$height,
      _ref$aspectRatio = _ref.aspectRatio,
      aspectRatio = _ref$aspectRatio === void 0 ? "" : _ref$aspectRatio,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? "cover" : _ref$fill;
  var widthValue = "";
  var heightValue = "";
  if (width !== undefined) widthValue = width;
  if (height !== undefined) heightValue = height;

  if (aspectRatio) {
    var _parseAspectRatio = parseAspectRatio(aspectRatio),
        _parseAspectRatio2 = _slicedToArray(_parseAspectRatio, 2),
        wx = _parseAspectRatio2[0],
        hx = _parseAspectRatio2[1];

    if (widthValue && heightValue === "auto") {
      var unit = getUnit(widthValue);
      heightValue = parseInt(widthValue, 10) / wx * hx;
      heightValue = "".concat(Math.round(heightValue)).concat(unit);
    } else if (heightValue && widthValue === "auto") {
      var _unit = getUnit(heightValue);

      widthValue = parseInt(heightValue, 10) / hx * wx;
      widthValue = "".concat(Math.round(widthValue)).concat(_unit);
    }
  }

  return (0, _react.jsx)("figure", {
    className: className,
    css: (0, _react.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        display: inline-flex;\n        box-sizing: border-box;\n        margin: 0;\n\n        border: ", " solid ", ";\n        border-radius: ", ";\n        overflow: hidden;\n        width: ", ";\n        height: ", ";\n\n        background: ", ";\n\n        line-height: 0;\n        font-size: 0;\n\n        cursor: default;\n        user-select: none;\n      "])), _theme["default"].borderSizeRegular, _theme["default"].colorLightTemp, _theme["default"].radiusRegular, widthValue, heightValue, _theme["default"].colorLightTemp)
  }, !!src ? (0, _react.jsx)("img", {
    alt: alt,
    css: (0, _react.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            object-fit: ", ";\n            width: 100%;\n            height: 100%;\n          "])), fill),
    src: src
  }) : (0, _react.jsx)(_Hold["default"], null, (0, _react.jsx)("span", {
    css: (0, _react.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            opacity: 0.25;\n            color\" ", ";\n          "])), _theme["default"].colorDarkTemp)
  }, (0, _react.jsx)(_Icon["default"], null, (0, _react.jsx)(_reactFeather.Image, null)))));
};

Picture.propTypes = {
  className: _propTypes["default"].string,
  alt: _propTypes["default"].string,
  src: _propTypes["default"].string.isRequired,
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  aspectRatio: _propTypes["default"].oneOf(_theme.ASPECT_RATIO_TYPES),
  fill: _propTypes["default"].oneOf(_theme.IMG_FIT_TYPES)
};
var _default = Picture;
exports["default"] = _default;